import { render, staticRenderFns } from "./TinyEditor.vue?vue&type=template&id=82c5112c"
import script from "./TinyEditor.vue?vue&type=script&lang=js"
export * from "./TinyEditor.vue?vue&type=script&lang=js"
import style0 from "./TinyEditor.vue?vue&type=style&index=0&id=82c5112c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports